// Single source of truth for the region. The old client derived this in three places.
import { browser } from '$app/environment';

/**
 * `nz.` / `au.` host prefix in production and on the test server; on localhost the Vite port is
 * the switch (5000 = NZ, 5005 = AU), matching the backend's CountryMiddleware.
 * @param {string} hostname
 * @param {string} port
 * @returns {'nz' | 'au'}
 */
export function detectCountry(hostname, port) {
	const first = (hostname || '').split('.')[0];
	if (first === 'au' || first === 'nz') return first;
	return port === '5005' ? 'au' : 'nz';
}

/** @type {'nz' | 'au'} */
export const code = browser ? detectCountry(location.hostname, location.port) : 'nz';
export const isAu = code === 'au';
export const countryName = isAu ? 'Australia' : 'New Zealand';
/** GST rate as a fraction, fixed per region. */
export const gstRate = isAu ? 0.1 : 0.15;
/** Tax added to retail prices in cart maths (AU retail prices are shown tax free). */
export const retailSalesTax = isAu ? 0 : 0.15;
